import React from 'react';

const SvgJm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="JM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="JM_svg__b" fill="#fff">
        <use xlinkHref="#JM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#JM_svg__a" />
      <path fill="#1DBE4F" mask="url(#JM_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#262626" mask="url(#JM_svg__b)" d="M0 0l12 10L0 20z" />
      <path
        fill="#262626"
        mask="url(#JM_svg__b)"
        transform="matrix(-1 0 0 1 44 0)"
        d="M16 0l12 10-12 10z"
      />
      <path
        d="M14 8.392L29.282-1.916l1.492 2.21L16.384 10l14.39 9.706-1.492 2.21L14 11.608-1.282 21.916l-1.492-2.21L11.616 10-2.774.294l1.492-2.21L14 8.392z"
        fill="#FFD646"
        mask="url(#JM_svg__b)"
      />
    </g>
  </svg>
);

export default SvgJm;
